import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthGuard from './auth-guard'
import Login from '@/view/Auth/Login'
// import Registration from '@/view/Auth/Registration'

import Home from '@/view/Home'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    // {
    //     path: '/registration',
    //     name: 'Registration',
    //     component: Registration
    // },
    {
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: AuthGuard,
    },
    {
        name: 'ChatList',
        path: '/pages/chat_list',
        component: () => import('@/view/dashboard/pages/ChatList'),
        beforeEnter: AuthGuard,
    },
    {
        name: 'DepartmentDictionary',
        path: '/pages/dictionary/department',
        component: () => import('@/view/dashboard/pages/dictionary/DepartmentList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'CompanyDictionary',
        path: '/pages/dictionary/company',
        component: () => import('@/view/dashboard/pages/dictionary/CompanyList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ServiceTypeDictionary',
        path: '/pages/dictionary/service_type',
        component: () => import('@/view/dashboard/pages/dictionary/ServiceTypeList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'LicenseTypeDictionary',
        path: '/pages/dictionary/license_type',
        component: () => import('@/view/dashboard/pages/dictionary/LicenseTypeList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ClientServiceTypeDictionary',
        path: '/pages/dictionary/client_service_type',
        component: () => import('@/view/dashboard/pages/dictionary/ClientServiceTypeList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'SoftwareVersionTypeDictionary',
        path: '/pages/dictionary/software_version_type',
        component: () => import('@/view/dashboard/pages/dictionary/SoftwareVersionTypeList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'SeriesNumberDictionary',
        path: '/pages/dictionary/series_number',
        component: () => import('@/view/dashboard/pages/dictionary/SeriesNumberList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ServiceImportanceDictionary',
        path: '/pages/dictionary/service_importance',
        component: () => import('@/view/dashboard/pages/dictionary/ServiceImportanceList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ServiceVisitTypeDictionary',
        path: '/pages/dictionary/service_visit_type',
        component: () => import('@/view/dashboard/pages/dictionary/ServiceVisitTypeList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'PositionTypeDictionary',
        path: '/pages/dictionary/position_type',
        component: () => import('@/view/dashboard/pages/dictionary/PositionTypeList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'DocumentTypeDictionary',
        path: '/pages/dictionary/document_type',
        component: () => import('@/view/dashboard/pages/dictionary/DocumentTypeList'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'Settings',
        path: '/pages/settings',
        component: () => import('@/view/dashboard/pages/Settings'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'Users',
        path: '/pages/users',
        component: () => import('@/view/dashboard/pages/Users'),
        meta:{
            role: 'Administrator'
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'Services',
        path: '/pages/service/list',
        props: route => Object.assign({}, route.query, route.params),
        component: () => import('@/view/dashboard/pages/service/ServiceList'),
        meta:{
            role: ['Administrator', 'ClientManager', 'Executor']
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ServicesCard',
        path: '/pages/service/card/:serviceId',
        component: () => import('@/view/dashboard/pages/service/ServiceCard'),
        props: true,
        meta:{
            role: ['Administrator', 'ClientManager']
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ExecutorServices',
        path: '/pages/executor/service/:assigned/list',
        props: route => Object.assign({}, route.query, route.params),
        component: () => import('@/view/dashboard/pages/executor/ServiceList'),
        meta:{
            role: ['Administrator', 'Executor']
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ExecutorServicesCard',
        path: '/pages/executor/service/card/:serviceId',
        component: () => import('@/view/dashboard/pages/executor/ServiceCard'),
        props: true,
        meta:{
            role: ['Administrator', 'Executor']
        },
        beforeEnter: AuthGuard,
    },

    {
        name: 'Clients',
        path: '/pages/client/list',
        props: route => Object.assign({}, route.query, route.params),
        component: () => import('@/view/dashboard/pages/client/ClientList'),
        meta:{
            role: ['Administrator', 'ClientManager', 'Executor']
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ClientsCard',
        path: '/pages/client/card/:clientId',
        component: () => import('@/view/dashboard/pages/client/ClientCard'),
        props: true,
        meta:{
            role: ['Administrator', 'ClientManager', 'Executor']
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ClientTicketList',
        path: '/pages/client/ticket/list',
        props: route => Object.assign({}, route.query, route.params),
        component: () => import('@/view/dashboard/pages/clientTickets/ClientTicketList'),
        meta:{
            role: ['Administrator', 'ClientManager']
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'ClientTicketCard',
        path: '/pages/client/:clientId/ticket/card/:ticketId',
        props: route => Object.assign({}, route.query, route.params),
        component: () => import('@/view/dashboard/pages/clientTickets/ClientTicketCard'),
        meta:{
            role: ['Administrator', 'ClientManager']
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'KnowledgeBase',
        path: '/pages/knowledgebase/list',
        component: () => import('@/view/dashboard/pages/knowledgeBase/KnowledgeBaseList'),
        props: true,
        meta:{
            role: ['Administrator', 'ClientManager', 'Executor']
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'KnowledgeBaseCard',
        path: '/pages/knowledgebase/card/:knowledgeBaseId',
        component: () => import('@/view/dashboard/pages/knowledgeBase/KnowledgeBaseCard'),
        props: true,
        meta:{
            role: ['Administrator', 'ClientManager', 'Executor']
        },
        beforeEnter: AuthGuard,
    },
    {
        name: 'Profile',
        path: '/profile',
        component: () => import('@/view/dashboard/pages/UserProfile'),
        props: true,
        beforeEnter: AuthGuard,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
